export const generateLastMonthDates = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const dateout = `${year}-${month}-${day}`;

  const lastMonth = new Date(today);
  lastMonth.setDate(today.getDate() - 30);
  const lastMonthYear = lastMonth.getFullYear();
  const lastMonthMonth = String(lastMonth.getMonth() + 1).padStart(2, '0');
  const lastMonthDay = String(lastMonth.getDate()).padStart(2, '0');
  const datein = `${lastMonthYear}-${lastMonthMonth}-${lastMonthDay}`;

  return {
    datein,
    dateout,
  };
};
